export default "__VITE_ASSET__DEo_clrI__"